import React, { useEffect, useState } from "react";
import { Alert, Button, Card } from "react-bootstrap";
import EmailIcon from "@enerex/unified-ui-react/icons/EmailIcon";
import { DEV_URL, setTokenGetter } from "utils/requests";
import DataHubLogo from "@enerex/unified-ui-react/logos/DataHubLogo";

const EmailVerification = () => {
  const [resendLoading, setResendLoading] = useState(false);
  const [resendError, setResendError] = useState("");
  const [resendSuccess, setResendSuccess] = useState("");
  const [emailToVerify, setEmailToVerify] = useState("");

  // Public page: provide a safe token getter for shared request helper.
  useEffect(() => {
    setTokenGetter(() => "");
    const stored = sessionStorage.getItem("datahubVerificationEmail") || "";
    setEmailToVerify(stored);
  }, []);

  const handleResend = async () => {
    setResendError("");
    setResendSuccess("");

    const email = (emailToVerify || "").trim();
    if (!email) {
      setResendError("Email address not found. Please sign up again.");
      return;
    }

    setResendLoading(true);
    try {
      const res = await fetch(`${DEV_URL}/api/client/user/resend-verificationmail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        // Backend expects [FromBody] string emailAddress; send JSON string
        body: JSON.stringify(email),
      });

      if (!res.ok) {
        setResendError("Something went wrong. Try again");
        return;
      }

      setResendSuccess("Email sent successfully");
    } catch (e) {
      setResendError("Something went wrong. Try again");
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "calc(100vh - 180px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px 12px",
        backgroundColor: "#f5f6fa",
      }}
    >
      <div style={{ width: "100%", maxWidth: 680 }}>
        <div className="text-center mb-4">
          <DataHubLogo aria-label="DataHub" style={{ height: 52, width: "auto" }} />
        </div>

        <Card
          style={{
            maxWidth: 430,
            margin: "0 auto",
            borderRadius: 12,
            border: "1px solid #e9ecf2",
            boxShadow: "0 6px 18px rgba(19,28,69,0.08)",
          }}
        >
          <Card.Body style={{ padding: "28px 24px" }}>
            <div className="text-center mb-3">
              <div
                style={{
                  width: 58,
                  height: 58,
                  margin: "0 auto 12px",
                  borderRadius: "50%",
                  backgroundColor: "#f1f3f8",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <EmailIcon style={{ fontSize: 24, color: "#2f3b69" }} />
              </div>
              <h4 style={{ color: "#131c45", marginBottom: 8 }}>Check Your Email</h4>
              <p className="text-muted mb-2">
                We have sent a verification link to your email address.
              </p>
              <p className="text-muted mb-0">Please click the link in the email to continue.</p>
            </div>

            

            <div className="text-center mt-3" style={{ borderTop: "1px solid #e9ecf2", paddingTop: 14 }}>
              <p className="text-muted mb-2">Did not receive the email? Check your spam folder.</p>
              <Button
                variant="outline-primary"
                size="sm"
                disabled={resendLoading}
                onClick={handleResend}
              >
                Resend Verification Email
              </Button>

              {resendSuccess && (
                <Alert variant="success" className="mt-3 mb-0">
                  {resendSuccess}
                </Alert>
              )}
              {resendError && (
                <Alert variant="danger" className="mt-3 mb-0">
                  {resendError}
                </Alert>
              )}
            </div>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default EmailVerification;
